import { Action, createAction, handleActions } from "redux-actions";
import { GetSolicitudesEmisionResponse, SolicitudEmision } from "~api/types";
import {
  Dispatch,
  FechaFiltro,
  FiltroValue,
  GetState,
  Services,
  TakeValue,
} from "../types";

/**
 * `solicitudesEmision` queda en null al reinicializar la bandeja: es el estado
 * previo a la primera respuesta, distinto de "no hay resultados".
 */
interface SolicitudesPendientesSucursalState {
  isLoading: boolean;
  solicitudesEmision: SolicitudEmision[] | null;
  totalRegistros: number;
  isPageAlreadyLoad?: boolean;
  skip?: number;
  take?: TakeValue;
}

const setInitialState = createAction("SET_SOLICITUDESEMISION_INITIAL_STATE");

const getSolicitudesEmisionInited = createAction(
  "OBTENER_SOLICITUDESEMISION_INITED"
);

const getSolicitudesEmisionCompleted = createAction(
  "OBTENER_SOLICITUDESEMISION_COMPLETED",
  (response: GetSolicitudesEmisionResponse | null | undefined) => {
    let solicitudesEmision: SolicitudEmision[] = [];
    let totalRegistros = 0;

    if (response != null) {
      solicitudesEmision = response.solicitudesEmision;
      totalRegistros = response.totalRegistros;
    }

    return { solicitudesEmision, totalRegistros };
  }
);

const getSolicitudesEmisionFailed = createAction(
  "OBTENER_SOLICITUDESEMISION_FAILED",
  (error: unknown) => ({
    error,
  })
);

const getSolicitudesEmision = (
  skip: number,
  take: TakeValue,
  searchCriteria?: string | null,
  fechaDesde?: FechaFiltro,
  fechaHasta?: FechaFiltro,
  estado?: FiltroValue | FiltroValue[] | null,
  dniCliente?: string | null
) => {
  return async (dispatch: Dispatch, getState: GetState, services: Services) => {
    try {
      dispatch(getSolicitudesEmisionInited());

      const estados = Array.isArray(estado)
        ? estado.map(String)
        : estado
          ? [String(estado)]
          : undefined;

      const data = {
        skip: skip,
        take: Number(take),
        searchCriteria: searchCriteria ?? undefined,
        fechaDesde: fechaDesde || undefined,
        fechaHasta: fechaHasta || undefined,
        estado: estados,
        dniCliente: dniCliente ?? undefined,
        negocio: "MercadoAbierto",
      };

      const response = await services.api
        .solicitudesEmision()
        .getSolicitudesEmision(data);

      dispatch(getSolicitudesEmisionCompleted(response));
    } catch (error) {
      console.error(error);
      dispatch(getSolicitudesEmisionFailed(error));
    }
  };
};

const solicitudesEmisionInitialState: SolicitudesPendientesSucursalState = {
  isLoading: false,
  solicitudesEmision: null,
  totalRegistros: 0,
};

const solicitudesPendientesSucursalReducer = handleActions<
  SolicitudesPendientesSucursalState,
  any
>(
  {
    [setInitialState.toString()]: (): SolicitudesPendientesSucursalState => {
      return {
        ...solicitudesEmisionInitialState,
        solicitudesEmision: null,
        isLoading: false,
      };
    },
    [getSolicitudesEmisionInited.toString()]: (
      state: SolicitudesPendientesSucursalState
    ): SolicitudesPendientesSucursalState => {
      return {
        ...state,
        totalRegistros: 0,
        isLoading: true,
      };
    },
    [getSolicitudesEmisionCompleted.toString()]: (
      state: SolicitudesPendientesSucursalState,
      action: Action<{
        solicitudesEmision: SolicitudEmision[];
        totalRegistros: number;
      }>
    ): SolicitudesPendientesSucursalState => {
      return {
        ...state,
        solicitudesEmision: action.payload.solicitudesEmision,
        totalRegistros: action.payload.totalRegistros,
        isPageAlreadyLoad: false,
        isLoading: false,
        skip: Number(state.skip) + Number(state.take),
      };
    },
    [getSolicitudesEmisionFailed.toString()]: (
      state: SolicitudesPendientesSucursalState
    ): SolicitudesPendientesSucursalState => {
      return {
        ...state,
        isPageAlreadyLoad: false,
        isLoading: false,
      };
    },
  },
  solicitudesEmisionInitialState
);

export { solicitudesPendientesSucursalReducer };
export { getSolicitudesEmision, setInitialState };
